import validate from "/var/www/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45client_45side_45navigation_45global from "/var/www/node_modules/@backmarket/nuxt-layer-base/middleware/01.clientSideNavigation.global.ts";
import guest from "/var/www/packages/nuxt-module-oauth/src/runtime/middleware/guest.ts";
import auth from "/var/www/packages/nuxt-module-oauth/src/runtime/middleware/auth.ts";
import logger from "/var/www/packages/nuxt-module-logger/src/runtime/middleware.ts";
import instrumentation_46setResourceName from "/var/www/packages/nuxt-module-instrumentation/src/runtime/middleware/setResourceName.ts";
import manifest_45route_45rule from "/var/www/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45client_45side_45navigation_45global,
  guest,
  auth,
  logger,
  instrumentation_46setResourceName,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-bouygues-experiment": () => import("/var/www/apps/front-office/middleware/checkBouyguesExperiment.ts"),
  "log-attempt": () => import("/var/www/apps/front-office/middleware/logAttempt.ts"),
  "redirect-if-cart-empty": () => import("/var/www/apps/front-office/middleware/redirectIfCartEmpty.ts"),
  "redirect-if-missing-collection-point": () => import("/var/www/apps/front-office/middleware/redirectIfMissingCollectionPoint.ts"),
  "redirect-if-missing-shipping": () => import("/var/www/apps/front-office/middleware/redirectIfMissingShipping.ts")
}